import axios from 'axios';
import { call } from 'redux-saga/effects';
import { getTokenHeaders as tokenHeader } from '../helpers/api.helper';
import { 
    GET_SAVED_NEWS_ENDPOINT, 
    GET_FAVORITE_CINEMAS_ENDPOINT, 
    GET_YOUR_RETINGS_ENDPOINT, 
    GET_FAVORITE_MOVIES_ENDPOINT, 
    GET_UNVIEWED_NOTIFICATIONS_COUNT_ENDPOINT, 
    GET_USER_DETAILS_ENDPOINT, 
    GET_NOTIFICATION_LIST_ENDPOINT, 
    READ_NOTIFICATION_ENDPOINT, 
    DELETE_NOTIFICATION_ENDPOINT,
    REMOVE_MOVIE_FROM_FAVORITE_ENDPOINT, 
    REMOVE_NEWS_FROM_FAVORITE_ENDPOINT,
    REMOVE_CINEMA_FROM_FAVORITE_ENDPOINT} from '../config/apiEndpoints';

export function* getSavedNews(payload) {
    const header = tokenHeader();
    const userId = localStorage.getItem('user_id')
    return yield call(axios.get, GET_SAVED_NEWS_ENDPOINT + userId, header);
}

export function* getSavedNewsAfterDelete(payload){
    const header = tokenHeader();
    const userId = localStorage.getItem('user_id')
    const url =  GET_SAVED_NEWS_ENDPOINT + userId + `?_format=api_json&items_per_page=${payload.items_per_page}&page=${payload.page}`;
    return yield call(axios.get, url, header);
}

export function* getSavedNewsSeeMore(payload) {
    const header = tokenHeader();
    const userId = localStorage.getItem('user_id')
    const url = GET_SAVED_NEWS_ENDPOINT + userId + `?_format=api_json&items_per_page=2&page=${payload}`;
    return yield call(axios.get, url, header);
}

export function* getFavoriteCinemas(payload) {
    const header = tokenHeader();
    const userId = localStorage.getItem('user_id')
    const url = GET_FAVORITE_CINEMAS_ENDPOINT + userId + '?_format=api_json&items_per_page=2';
    return yield call(axios.get, url, header); 
}

export function* getFavoriteCinemasAfterDelete(payload) {
    const header = tokenHeader();
    const userId = localStorage.getItem('user_id')
    const url = GET_FAVORITE_CINEMAS_ENDPOINT + userId + `?_format=api_json&items_per_page=${payload.items_per_page}&page=${payload.page}`;
    return yield call(axios.get, url, header); 
}

export function* getFavoriteCinemasSeeMore(payload) {
    const header = tokenHeader();
    const userId = localStorage.getItem('user_id')
    const url = GET_FAVORITE_CINEMAS_ENDPOINT + userId + `?_format=api_json&items_per_page=2&page=${payload}`;
    
    return yield call(axios.get, url, header); 
}

export function* getYourRatings(payload){
    const header = tokenHeader();
    const userId = localStorage.getItem('user_id')
    const url = GET_YOUR_RETINGS_ENDPOINT + userId + "?_format=api_json&items_per_page=All";

    return yield call(axios.get, url, header);
}

export function* getFavoriteMovies(payload){
    const header = tokenHeader();
    const userId = localStorage.getItem('user_id')

    return yield call(axios.get, GET_FAVORITE_MOVIES_ENDPOINT + userId, header);
}

export function* getFavoriteMoviesSeeMore(payload){
    const header = tokenHeader();
    const userId = localStorage.getItem('user_id');
    const url = GET_FAVORITE_MOVIES_ENDPOINT + userId + `?_format=api_json&items_per_page=3&page=${payload}`;

    return yield call(axios.get, url, header);
}

export function* getFavoriteMoviesAfterDelete(payload){
    const header = tokenHeader();
    const userId = localStorage.getItem('user_id');
    const url = GET_FAVORITE_MOVIES_ENDPOINT + userId + `?_format=api_json&items_per_page=${payload.items_per_page}&page=${payload.page}`;

    return yield call(axios.get, url, header);
}

export function* getUnviewedNotificationCount(payload){
    const header = tokenHeader();

    return yield call(axios.get, GET_UNVIEWED_NOTIFICATIONS_COUNT_ENDPOINT, header);
}

export function* getUserDetails(payload){
    const header = tokenHeader();
    const url = GET_USER_DETAILS_ENDPOINT + localStorage.getItem("user_id") + '?_format=api_json';
    return yield call(axios.get, url, header);
}

export function* getNotificationList(payload){
    const header = tokenHeader();

    return yield call(axios.get, GET_NOTIFICATION_LIST_ENDPOINT, header);
}

export function* readNotification(payload){
    const header = tokenHeader();

    return yield call(axios.patch, READ_NOTIFICATION_ENDPOINT + payload, {}, header);
}

export function* deleteNotification(payload){
    const header = tokenHeader();

    return yield call(axios.delete, DELETE_NOTIFICATION_ENDPOINT + payload, header);
}   

export function* removeMovieFromFavorite(payload){
    const header = tokenHeader();
    return yield call(axios.delete, REMOVE_MOVIE_FROM_FAVORITE_ENDPOINT + payload, header);
}

export function* removeNewsFromFavorite(payload){
    const header = tokenHeader();
    return yield call(axios.delete, REMOVE_NEWS_FROM_FAVORITE_ENDPOINT + payload, header);
}

export function* removeCinemaFromFavorite(payload){
    const header = tokenHeader();
    return yield call(axios.delete, REMOVE_CINEMA_FROM_FAVORITE_ENDPOINT + payload, header);
}


// WEBPACK FOOTER //
// ./src/SHARED/api/profile.api.js